<template>
  <v-chip small :color="chipColor" dark>
    {{ statusLabel }}
  </v-chip>
</template>

<script>
export default {
  name: "PayoutStatusChipField",
  props: {
    payout: {
      type: Object,
      default: null
    }
  },
  computed: {
    statusLabel() {
      if (this.payout?.paid) return "Paid";
      if (this.payout?.effective === false) return "Expired";
      return "Unpaid";
    },
    chipColor() {
      const status = this.statusLabel;
      if (status === "Paid") return "success";
      if (status === "Expired") return "error";
      if (status === "Unpaid") return "warn";
      return "warn";
    }
  }
};
</script>
